var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8471 13.6294C12.0997 13.8826 12.1 14.2932 11.8471 14.5463L10.0522 16.3413L9.97698 16.4096C9.61507 16.7047 9.09192 16.7045 8.7299 16.4096L8.65471 16.3413L6.85979 14.5463L6.77678 14.4448C6.61048 14.1931 6.63835 13.8511 6.85979 13.6294C7.08145 13.4077 7.42345 13.38 7.67522 13.5463L7.77678 13.6294L8.70451 14.5571L8.70451 10.6958C8.7046 10.3377 8.99483 10.0474 9.35295 10.0473C9.71111 10.0473 10.0013 10.3376 10.0014 10.6958L10.0014 14.5571L10.9291 13.6294L11.0317 13.5463C11.2834 13.3802 11.6255 13.4078 11.8471 13.6294Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1011 14.285C14.6302 13.7663 15.0748 13.1615 15.412 12.4934C15.8751 11.5759 16.1359 10.539 16.1359 9.44111C16.1359 5.69507 13.0992 2.65832 9.35313 2.65832C5.6071 2.65832 2.57034 5.69507 2.57034 9.44111C2.57034 10.539 2.83118 11.5759 3.29426 12.4934C3.58321 13.0658 3.95088 13.5917 4.38307 14.0569",
    stroke: "#EB5757",
    strokeWidth: 1.29719,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankDown);
export default __webpack_public_path__ + "static/media/rank-down.66739f48f59440e370d9c84ef571762e.svg";
export { ForwardRef as ReactComponent };